import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "../../common/rask-common.module";
import { ExampleUsageComponent } from "./example-usage.component";

@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        ExampleUsageComponent
    ]
})
export class ExampleModule { }
